import { forwardRef } from "react";

/**
 * MentionTooltip - displays user or command information on mention hover
 */
const MentionTooltip = forwardRef(
  (
    { mentionTooltip, mentionTooltipRender, onMouseEnter, onMouseLeave },
    ref,
  ) => {
    if (!mentionTooltip) return null;

    return (
      <div
        ref={ref}
        className="mention-tooltip"
        style={{ top: mentionTooltip.top, left: mentionTooltip.left }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {mentionTooltip.render ? (
          mentionTooltip.render(mentionTooltip.user)
        ) : mentionTooltipRender ? (
          mentionTooltipRender(mentionTooltip.user)
        ) : (
          <>
            <div className="mention-tooltip-name">
              {mentionTooltip.user?.label}
            </div>
            {mentionTooltip.user?._employee && (
              <div className="mention-tooltip-row">
                {mentionTooltip.user._employee}
              </div>
            )}
            {mentionTooltip.user?.email && (
              <div className="mention-tooltip-row">
                {mentionTooltip.user.email}
              </div>
            )}
          </>
        )}
      </div>
    );
  },
);

MentionTooltip.displayName = "MentionTooltip";

export default MentionTooltip;
